exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Open Sans,Crimson Text;font-weight:600;margin-top:2px;font-size:.8rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bfbbc04","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/candidates/ApplicationForm.vue
// module id = 624
// module chunks = 0